'use strict';
/* eslint no-console: 0 */
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeHelpers = require('event-tracking-tools/utils/typeHelpers');

var _ = require('_');

var EVENT_EXCEPTION_NAME = 'EventPropTypesException';

function createMessage(name, key, prop) {
  return 'event property \'' + key + '\' expected ' + name + ' but got ' + prop;
}

function EventPropTypesException(name, key, prop, record) {
  this.message = createMessage(name, key, prop, record);
  this.name = EVENT_EXCEPTION_NAME;
  this.eventPassed = record;
}

function _throw(name, key, prop, useStrict, record) {
  if (useStrict) {
    throw new EventPropTypesException(name, key, prop, record);
  } else {
    console.warn(EVENT_EXCEPTION_NAME + ': ' + createMessage(name, key, prop, record) + ' in ' + JSON.stringify(record));
  }
}

function _buildEventPropType(name, callback) {
  callback.getStringValue = function () {
    return name;
  };
  callback.isEventPropType = true;
  return callback;
}

var eventPropTypes = {
  REQUIRED: _buildEventPropType('REQUIRED', function (key, prop, useStrict, record) {
    var isValid = prop !== null && prop !== undefined;
    if (!isValid) {
      _throw('REQUIRED', key, prop, useStrict, record);
    }
  }),
  NOT_NULL: _buildEventPropType('NOT_NULL', function (key, prop, useStrict, record) {
    var isValid = prop !== null;
    if (!isValid) {
      _throw('NOT_NULL', key, prop, useStrict, record);
    }
  }),
  NOT_UNDEFINED: _buildEventPropType('NOT_UNDEFINED', function (key, prop, useStrict, record) {
    var isValid = prop !== undefined;
    if (!isValid) {
      _throw('NOT_UNDEFINED', key, prop, useStrict, record);
    }
  }),
  NUMBER: _buildEventPropType('NUMBER', function (key, prop, useStrict, record) {
    var isValid = (0, _.isNumber)(prop);
    if (!isValid) {
      _throw('NUMBER', key, prop, useStrict, record);
    }
  }),
  STRING: _buildEventPropType('STRING', function (key, prop, useStrict, record) {
    var isValid = (0, _.isString)(prop);
    if (!isValid) {
      _throw('STRING', key, prop, useStrict, record);
    }
  }),
  BOOLEAN: _buildEventPropType('BOOLEAN', function (key, prop, useStrict, record) {
    var isValid = (0, _.isBoolean)(prop);
    if (!isValid) {
      _throw('BOOLEAN', key, prop, useStrict, record);
    }
  }),
  OBJECT: _buildEventPropType('OBJECT', function (key, prop, useStrict, record) {
    var isValid = (0, _typeHelpers.isObject)(prop);
    if (!isValid) {
      _throw('OBJECT', key, prop, useStrict, record);
    }
  }),
  ARRAY: _buildEventPropType('ARRAY', function (key, prop, useStrict, record) {
    var isValid = (0, _.isArray)(prop);
    if (!isValid) {
      _throw('ARRAY', key, prop, useStrict, record);
    }
  }),
  ONE_OF: function ONE_OF() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var wrappedOneOf = _buildEventPropType('ONE_OF', function (key, prop, useStrict, record) {
      var isValid = options.indexOf(prop) !== -1;
      if (!isValid) {
        _throw('ONE_OF', key, prop, useStrict, record);
      }
    });
    return wrappedOneOf;
  }
};

exports.default = eventPropTypes;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/event-tracking-tools/static-1.15/js/events/eventPropTypes.js
// module id = 209
// module chunks = 0